import { render } from "./HouseModel.vue?vue&type=template&id=4b62dd9c"
import script from "./HouseModel.vue?vue&type=script&lang=js"
export * from "./HouseModel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__